// @flow

import * as React from 'react';

import { withPageMeta } from '@gandi/app-runner';

import Presenter from './Presenter';

export default (withPageMeta(args => ({
  title: args.__('Credit cloud account - Gandi Cloud - Gandi.net'),
}))(Presenter): React.ComponentType<{}>);
